/**
 * Get the what3 words words
 * @param {string} coordinates 'lat,lon'
 */
export const getWhat3Words = async (coordinates) => {
  // eg. https://api.what3words.com/v3/convert-to-3wa?coordinates=-32.88476,151.78661&language=en&key=DVG0QD06
  const what3wordsEndpoint = 'https://api.what3words.com/v3/convert-to-3wa';
  const what3wordsApiKey = 'T7YEEI4N';
  const what3wordsLanguage = 'en';
  const requestAddress = `${what3wordsEndpoint}?coordinates=${coordinates}&language=${what3wordsLanguage}&key=${what3wordsApiKey}`;

  const postResponse = await fetch(requestAddress, {
    method: 'GET',
    // mode: 'cors',
  });
  const postResponseJson = await postResponse.json();

  // TODO: add error handling

  return postResponseJson.words;
};

export const initialize = () => {};
